/* vr-patches.js — consolidacion de parches inline VR (2026-07-22).
   Cargado con defer. Cada bloque va en su propio try/catch para que un fallo
   en uno no tumbe los demas. window.vrConfig (definido inline en theme.liquid,
   trae valores Liquid) se usa donde haga falta.
   Ver bitacora/2026-07-22-auditoria-clarity-plan-rebuild.md */

/* === vr-variant-sync-verify — Fase 1 A3 (2026-06-02) ===
   SSoT del variant id: el hidden <input name="id"> es la verdad para ATC. */
try {
  (function () {
    function computeVariantIdFromVisualSelection(form) {
      var vs = (form && form.querySelector && form.querySelector('variant-selects'))
            || document.querySelector('variant-selects');
      if (!vs) return null;
      var fieldsets = vs.querySelectorAll('fieldset');
      var options = [];
      for (var i = 0; i < fieldsets.length; i++) {
        var fs = fieldsets[i];
        var checked = fs.querySelector('input[type="radio"]:checked')
                   || fs.querySelector('input[type="radio"].checked')
                   || fs.querySelector('input[type="radio"][checked]');
        if (!checked) return null;
        options.push(checked.value);
      }
      var jsonEl = document.getElementById('vr-product-variants');
      if (!jsonEl) return null;
      try {
        var variants = JSON.parse(jsonEl.textContent);
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          if (!v.options || v.options.length !== options.length) continue;
          var match = true;
          for (var j = 0; j < options.length; j++) {
            if (v.options[j] !== options[j]) { match = false; break; }
          }
          if (match) return v.id;
        }
      } catch (e) {}
      return null;
    }

    function verifyVariantSync(form, action) {
      var hidden = form && form.querySelector ? form.querySelector('input[name="id"]') : null;
      if (!hidden) return true;
      var hiddenId = parseInt(hidden.value, 10);
      var visualId = computeVariantIdFromVisualSelection(form);
      if (visualId && hiddenId !== visualId) {
        console.error('[VR][' + (action || 'unknown') + '] MISMATCH visual=' + visualId + ' hidden=' + hiddenId + ' — re-syncing');
        hidden.value = String(visualId);
        return false;
      }
      return true;
    }

    window.computeVariantIdFromVisualSelection = computeVariantIdFromVisualSelection;
    window.verifyVariantSync = verifyVariantSync;

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches || !form.matches('form[id^="product-form-"]')) return;
      if (!verifyVariantSync(form, 'cart-submit')) {
        e.preventDefault();
        console.warn('[VR] Cart submission blocked due to variant mismatch. Re-sync applied; please click ATC again.');
      }
    }, true);

    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.shopify-payment-button__button');
      if (!btn) return;
      var form = btn.closest('form') || document.querySelector('form[id^="product-form-"]');
      if (form) verifyVariantSync(form, 'express-checkout');
    }, true);
  })();
} catch (e) { console.error('[vr-patches] vr-variant-sync-verify failed:', e); }

/* === vr-variant-autoselect (rest of controller): fallback, optimistic, safety, express checkout ===
   La parte de redirect sincronico (window.location.replace pre-render) se quedo inline en theme.liquid. */
try {
  (function () {
    function getVariants() {
      var el = document.getElementById('vr-product-variants');
      if (!el) return null;
      try { return JSON.parse(el.textContent); } catch (e) { return null; }
    }

    function getVS() { return document.querySelector('variant-selects'); }

    function getFieldsets() {
      var vs = getVS();
      return vs ? Array.prototype.slice.call(vs.querySelectorAll('fieldset')) : [];
    }

    function getCheckedValueInFieldset(fs) {
      var checked = fs.querySelector('input[type="radio"]:checked');
      if (!checked) checked = fs.querySelector('input[type="radio"].checked');
      return checked ? checked.value : null;
    }

    function findVariantByOptions(opts) {
      var variants = getVariants();
      if (!variants) return null;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (!v.options || v.options.length !== opts.length) continue;
        var match = true;
        for (var j = 0; j < opts.length; j++) {
          if (v.options[j] !== opts[j]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    function getCurrentVariant() {
      var el = document.querySelector('script[data-selected-variant]');
      if (el) {
        try {
          var v = JSON.parse(el.textContent);
          if (v && v.id) {
            var variants = getVariants();
            if (variants) {
              for (var i = 0; i < variants.length; i++) {
                if (variants[i].id === v.id) return variants[i];
              }
            }
            return v;
          }
        } catch (e) {}
      }
      var sel = getFieldsets().map(getCheckedValueInFieldset);
      for (var i = 0; i < sel.length; i++) { if (sel[i] === null) return null; }
      return findVariantByOptions(sel);
    }

    var fallbackInProgress = false;

    function onVariantChangeCapture(e) {
      if (fallbackInProgress) return;
      var changed = e.target;
      if (!changed || changed.tagName !== 'INPUT' || changed.type !== 'radio') return;
      if (!changed.closest('variant-selects')) return;
      var changedFs = changed.closest('fieldset');
      if (!changedFs) return;

      var variants = getVariants();
      if (!variants) return;
      var fieldsets = getFieldsets();
      var changedIdx = fieldsets.indexOf(changedFs);
      if (changedIdx === -1) return;

      var selection = fieldsets.map(getCheckedValueInFieldset);
      var current = findVariantByOptions(selection);
      if (current && current.available) return;

      var userValue = selection[changedIdx];
      if (!userValue) return;
      var fallback = null;
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].options[changedIdx] === userValue && variants[i].available) {
          fallback = variants[i];
          break;
        }
      }
      if (!fallback) return;

      fallbackInProgress = true;
      for (var fi = 0; fi < fieldsets.length; fi++) {
        if (fi === changedIdx) continue;
        var desired = fallback.options[fi];
        var radios = fieldsets[fi].querySelectorAll('input[type="radio"]');
        for (var ri = 0; ri < radios.length; ri++) {
          var r = radios[ri];
          var lbl = document.querySelector('label[for="' + r.id + '"]');
          if (r.value === desired) {
            r.checked = true;
            if (lbl) lbl.classList.add('checked');
          } else {
            r.checked = false;
            if (lbl) lbl.classList.remove('checked');
          }
        }
      }
      fallbackInProgress = false;
    }

    function onChangeForSafetyTimeout(e) {
      if (!e.target.closest || !e.target.closest('variant-selects')) return;
      setTimeout(function () {
        var btns = document.querySelectorAll('.product-form__submit, .add-to-cart-button');
        for (var i = 0; i < btns.length; i++) {
          var btn = btns[i];
          if (!btn.disabled && !btn.hasAttribute('disabled')) continue;
          var text = (btn.textContent || '').trim().toLowerCase();
          if (text.indexOf('agotado') !== -1 || text.indexOf('sold out') !== -1) continue;
          btn.disabled = false;
          btn.removeAttribute('disabled');
        }
      }, 5000);
    }

    function onExpressCheckoutClick(e) {
      var btn = e.target.closest && e.target.closest('.shopify-payment-button__button');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      var v = getCurrentVariant();
      if (!v) { console.error('[VR] No variant matched current selection'); return; }
      if (!v.available) { console.error('[VR] Selected variant not available'); return; }

      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: v.id, quantity: 1 })
      })
        .then(function (r) { if (!r.ok) throw new Error('cart/add HTTP ' + r.status); return r.json(); })
        .then(function () { window.location.href = '/checkout'; })
        .catch(function (err) { btn.disabled = false; console.error('[VR] Express checkout error:', err); });
    }

    function init() {
      document.addEventListener('change', onVariantChangeCapture, true);
      document.addEventListener('change', onChangeForSafetyTimeout, false);
      document.addEventListener('click', onExpressCheckoutClick, true);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else { init(); }
  })();
} catch (e) { console.error('[vr-patches] vr-variant-autoselect (rest) failed:', e); }

/* === vr-variant-optimistic ===
   Actualiza .checked en el picker inmediatamente al click, antes que variant-selects
   empiece su fetch al servidor. */
try {
  (function () {
    function syncCheckedClass(e) {
      var target = e.target;
      var radio = null;
      if (target.tagName === 'INPUT' && target.type === 'radio') {
        radio = target;
      } else {
        var label = target.closest && target.closest('label');
        if (label && label.getAttribute('for')) {
          radio = document.getElementById(label.getAttribute('for'));
        }
      }
      if (!radio) return;
      var vs = radio.closest('variant-selects');
      if (!vs) return;
      var fs = radio.closest('fieldset');
      if (!fs) return;
      var allRadios = fs.querySelectorAll('input[type="radio"]');
      for (var i = 0; i < allRadios.length; i++) {
        var r = allRadios[i];
        var lbl = document.querySelector('label[for="' + r.id + '"]');
        if (r === radio) {
          r.classList.add('checked');
          if (lbl) lbl.classList.add('checked');
        } else {
          r.classList.remove('checked');
          if (lbl) lbl.classList.remove('checked');
        }
      }
    }
    document.addEventListener('click', syncCheckedClass, true);
  })();
} catch (e) { console.error('[vr-patches] vr-variant-optimistic failed:', e); }

/* === vr-express-checkout-conditional ===
   Muestra el express checkout solo si cart.total_price >= umbral. */
try {
  (function () {
    var THRESHOLD = 30000000; // $300.000 COP en centavos
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart && typeof cart.total_price === 'number' && cart.total_price >= THRESHOLD) {
          document.documentElement.classList.add('vr-express-checkout-eligible');
        }
      })
      .catch(function () { /* silencioso: si falla, boton queda oculto (fail-safe) */ });
  })();
} catch (e) { console.error('[vr-patches] vr-express-checkout-conditional failed:', e); }

/* === vr-cart-suppression-config: feedback visual al agregar al carrito ===
   Lee window.vrConfig.autoOpenThreshold (definido inline, viene de settings Liquid). */
try {
  (function () {
    window.__vrFireCartAddedFeedback = function () {
      try {
        var tpl = document.getElementById('vr-cart-toast-tpl');
        if (tpl && tpl.content) {
          document.querySelectorAll('.vr-cart-toast').forEach(function (p) { p.remove(); });
          var node = tpl.content.firstElementChild.cloneNode(true);
          document.body.appendChild(node);
          void node.offsetHeight;
          node.classList.add('is-visible');
          setTimeout(function () { node.classList.remove('is-visible'); setTimeout(function () { node.remove(); }, 180); }, 1020);
        }
        var bubbles = document.querySelectorAll('.cart-icon-bubble, .cart-count-bubble, .count-bubble');
        bubbles.forEach(function (b) { b.classList.remove('vr-bump'); void b.offsetHeight; b.classList.add('vr-bump'); setTimeout(function () { b.classList.remove('vr-bump'); }, 450); });
      } catch (e) { /* silent — item already added backend-side */ }
    };
    /* VR-FIX-CART-BADGES-2026-06-04 — sync all cart count badges (header desktop + bottom mobile). */
    window.__vrUpdateCartBadges = function (count) {
      try {
        var n = typeof count === 'number' ? count : 0;
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          var t = (el.textContent || '').trim();
          if (/^\(/.test(t) || /\)$/.test(t)) { el.textContent = '(' + n + ')'; }
          else { el.textContent = String(n); }
        });
        if (n > 0) {
          var cartLinks = document.querySelectorAll('a.cart-icon--drawer, a.header__icon--cart, button.header__icon--cart');
          cartLinks.forEach(function (link) {
            if (link.querySelector('[data-cart-count]')) return;
            var bubble = document.createElement('div');
            bubble.className = 'cart-count-bubble vr-injected-bubble';
            bubble.innerHTML = '<span aria-hidden="true" data-cart-count>' + n + '</span>';
            link.appendChild(bubble);
          });
        }
      } catch (e) { /* silent */ }
    };
  })();
} catch (e) { console.error('[vr-patches] vr-cart-suppression-config failed:', e); }

/* === vr-has-fallback (2026-07-22) ===
   Fallback JS para webviews Android sin soporte de CSS :has(). Sin :has(), las
   tallas/colores agotados quedaban seleccionables porque las reglas
   `color-swatch li:has(input.disabled)` y `li:has(input:checked)` nunca aplicaban.
   Aplica/quita clases equivalentes (.vr-unavailable / .vr-swatch-selected) leidas
   por vr-patches.css. El camino moderno con :has() queda intacto y corre en paralelo
   (redundante pero inofensivo) en navegadores que si lo soportan. */
try {
  (function () {
    var supportsHas = false;
    try { supportsHas = CSS.supports('selector(:has(*))'); } catch (e) { supportsHas = false; }
    if (supportsHas) return;

    var pending = false;
    function syncFallback() {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        document.querySelectorAll('variant-selects color-swatch li').forEach(function (li) {
          var radio = li.querySelector('input[type="radio"]');
          if (!radio) return;
          var isDisabled = radio.classList.contains('disabled');
          var isChecked = radio.checked || radio.classList.contains('checked') || radio.hasAttribute('checked');
          li.classList.toggle('vr-unavailable', isDisabled);
          li.classList.toggle('vr-swatch-selected', isChecked);
        });
      });
    }

    document.addEventListener('DOMContentLoaded', syncFallback);
    document.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('variant-selects')) syncFallback();
    }, true);
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('variant-selects')) syncFallback();
    }, true);

    // variant-selects se re-renderiza (fetch de Shopify) al cambiar de variante -> observar el DOM.
    var observer = new MutationObserver(syncFallback);
    if (document.body) {
      observer.observe(document.body, { childList: true, subtree: true });
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        observer.observe(document.body, { childList: true, subtree: true });
      });
    }

    syncFallback();
  })();
} catch (e) { console.error('[vr-patches] vr-has-fallback failed:', e); }
